import { create } from 'zustand';
import type { LedBarStepData } from '@/(routers)/boards/editor/block/definitions/fields/fieldLedBar';

type LedBarFieldRef = {
    setSteps: (steps: LedBarStepData[]) => void;
    getSteps: () => LedBarStepData[];
};

interface BlockModalLedBarState {
    fieldRef: LedBarFieldRef | null;
    setFieldRef: (ref: LedBarFieldRef) => void;
    clearFieldRef: () => void;
}

export const useBlockModalLedBarStore = create<BlockModalLedBarState>((set) => ({
    fieldRef: null,
    setFieldRef: (ref) => set({ fieldRef: ref }),
    clearFieldRef: () => set({ fieldRef: null }),
}));
